import { PartyService } from 'src/app/services/api/party/party.service';
import { Component, OnInit } from '@angular/core';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { CoverageService } from 'src/app/services/api/coverage/coverage.service';

@Component({
  selector: 'app-coverage-priorities',
  templateUrl: './coverage-priorities.component.html',
  styleUrls: ['./coverage-priorities.component.scss']
})
export class CoveragePrioritiesComponent implements OnInit {

  isps: string[];
  ispInos: string[];
  selectedInos: string[];
  selectedIsp: string;

  constructor(private breadcrumbsService: BreadcrumbsService, private coverageService: CoverageService,
    private partyService: PartyService) {

  }

  ngOnInit() {
    this.isps = [];
    this.selectedInos = [];
    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs: [{ title: 'Administración', url: 'provision/management' },
        { title: 'Cobertura FTTH', url: 'provision/management/coverage' },
        { title: 'Gestión de prioridades', url: 'provision/management/coverage/priorities' }
        ]
      });

    this.partyService.getCustomers().subscribe(
      (data) => {
        for (const party of data) {
          this.isps.push(party.name);
        }
        this.selectedIsp = this.isps[0].toLowerCase().replace(/[\s]/g, '');
        this.checkPriorities();
      }
    )
  }

  private insertAndShift(arr, from, to) {
    const cutOut = arr.splice(from, 1)[0];
    arr.splice(to, 0, cutOut);
  }

  private getCreatePrioritiesQuery(inos) {
    return {
      priorities: inos
    };
  }

  private getRemoveAliasQuery(inos) {
    const request = [];
    for (const ino of inos) {
      request.push({ remove: { index: '*_' + ino + '_*', alias: 'gescal37_current_' + this.selectedIsp } });
    }
    return request;
  }

  public upInos(selectedInos: string[]) {
    if (selectedInos.length !== this.ispInos.length && selectedInos.length === 1) {
      for (const selectedIno of selectedInos) {
        if (this.ispInos.findIndex(ino => ino === selectedIno) !== 0) {
          this.insertAndShift(
            this.ispInos,
            this.ispInos.findIndex(ino => ino === selectedIno),
            this.ispInos.findIndex(ino => ino === selectedIno) - 1);
        }
      }
    }
    this.coverageService.createIspPriorities(this.selectedIsp, this.getCreatePrioritiesQuery(this.ispInos)).subscribe();
  }

  public downInos(selectedInos: string[]) {
    if (selectedInos.length !== this.ispInos.length && selectedInos.length === 1) {
      for (const selectedIno of selectedInos) {
        if (this.ispInos.findIndex(ino => ino === selectedIno) !== this.ispInos.length - 1) {
          this.insertAndShift(
            this.ispInos,
            this.ispInos.findIndex(ino => ino === selectedIno),
            this.ispInos.findIndex(ino => ino === selectedIno) + 1);
        }
      }
    }
    this.coverageService.createIspPriorities(this.selectedIsp, this.getCreatePrioritiesQuery(this.ispInos)).subscribe();
  }

  public removeInos(selectedInos: string[]) {
    this.coverageService.configAliases(this.getRemoveAliasQuery(selectedInos)).subscribe(
      (data) => {
        for (const selectedIno of selectedInos) {
          this.ispInos.splice(this.ispInos.findIndex(ino => ino === selectedIno), 1);
        }
        this.coverageService.createIspPriorities(this.selectedIsp, this.getCreatePrioritiesQuery(this.ispInos)).subscribe(
          (data) => {
            this.coverageService.deleteIspCoverageFile(this.selectedIsp).subscribe();
          }
        );
      }
    );
  }

  public checkPriorities() {
    this.coverageService.getIspPriorities(this.selectedIsp).subscribe(
      (data) => {
        this.ispInos = data.priorities;
      },
      (err) => {
        this.ispInos = [];
      }
    )
  }

}
